import { render, staticRenderFns } from "./RatioDiv.vue?vue&type=template&id=45cc9d8a&scoped=true&"
import script from "./RatioDiv.vue?vue&type=script&lang=js&"
export * from "./RatioDiv.vue?vue&type=script&lang=js&"
import style0 from "./RatioDiv.vue?vue&type=style&index=0&id=45cc9d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc9d8a",
  null
  
)

export default component.exports